import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";

export interface DividerProps extends BaseUIProps {
  key?: string;
  margin?: ui.EdgeInsets;
  color?: ui.Color;
}

class _DividerState extends ObservableComponent<DividerProps> {
  static defaultProps = { margin: null, color: null };
  public constructor(props: DividerProps) {
    super(props);

    this.initState();
  }
  public get margin(): ui.EdgeInsets {
    return this.props.margin;
  }
  public get color(): ui.Color {
    return this.props.color;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["color", "margin"], this.rebuild);
  }
  public componentDidUpdate(prevProps: DividerProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.margin !== this.props.margin) {
      this.fire("margin", this);
    }

    if (prevProps.color !== this.props.color) {
      this.fire("color", this);
    }
  }
  public render(): ReactNode {
    return ui.Row({
      children: [
        ui.Container({
          decoration: new ui.BoxDecoration({ color: this.color }),
          alignment: ui.Alignment.center,
          margin: this.margin,
          states: ui.joinStates(
            { "data-c0": this.margin === null, "data-c1": this.color === null },
            {}
          ),
          className: "x54d hc vc h",
          key: "0",
        }),
      ],
      className: ui.join(this.props.className, "Divider x13 hc h"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function Divider(props: DividerProps) {
  return React.createElement(_DividerState, {
    ..._DividerState.defaultProps,
    ...props,
  });
}
